import { Component, OnInit } from '@angular/core';
import { DistrictAddEditComponent, IT_MANAGEMENT_COMPONENT, UserModuleApiSuffixModels } from '@app/modules';
import { AppState } from '@app/reducers';
import { CrudType, IApplicationResponse, LoggedInUserModel, ModulesBasedApiSuffix, ReusablePrimeNGTableFeatureService, SnackbarService, addDefaultTableObjectProperties, checkUserPermissionsByCategory, currentComponentPageBasedPermissionsSelector$, onActionSubmittedUtil, prepareDynamicTableTabsFromPermissions, prepareGetRequestHttpParams } from '@app/shared';
import { CrudService, RxjsService, } from '@app/shared/services';
import { loggedInUserData } from '@modules/others';
import { DistrictModel } from '@modules/user/models';
import { Store } from '@ngrx/store';
import { DialogService } from 'primeng/api';
import { combineLatest } from 'rxjs';
import { PrimeNgTableVariablesModel } from '../../../../../shared/models/prime-ng-table-list-component-variables.model';
@Component({
  selector: 'app-district-list',
  templateUrl: './district-list.component.html',
})
export class DistrictListComponent extends PrimeNgTableVariablesModel implements OnInit {
  primengTableConfigProperties: any = {
    tableCaption: "District",
    selectedTabIndex: 0,
    breadCrumbItems: [{ displayName: 'IT Management ', relativeRouterUrl: '' }, { displayName: 'District List' }],
    tableComponentConfigs: {
      tabsList: [
        {
          caption: 'District',
          dataKey: 'districtId',
          enableAction: true,
          enableMultiDeleteActionBtn: true,
          enableStatusActiveAction: true,
          checkBox: true,
          enableRowDelete: true,
          columns: [{ field: 'districtName', header: 'District Name' },
          { field: 'divisionName', header: 'Division Name' },
          { field: 'isActive', header: 'Status' }
          ],
          apiSuffixModel: UserModuleApiSuffixModels.DISTRICT,
          moduleName: ModulesBasedApiSuffix.IT_MANAGEMENT
        }]
    }
  }

  constructor(private crudService: CrudService,
    private rxjsService: RxjsService,
    private reusablePrimeNGTableFeatureService: ReusablePrimeNGTableFeatureService,
    private store: Store<AppState>,
    public dialogService: DialogService,
    private snackbarService: SnackbarService) {
    super();
    this.primengTableConfigProperties = addDefaultTableObjectProperties(this.primengTableConfigProperties);
  }

  ngOnInit(): void {
    this.getDistricts();
    this.combineLatestNgrxStoreData();
  }

  combineLatestNgrxStoreData() {
    combineLatest([
      this.store.select(loggedInUserData),
      this.store.select(currentComponentPageBasedPermissionsSelector$)]
    ).subscribe((response) => {
      this.loggedInUserData = new LoggedInUserModel(response[0]);
      let permission = response[1][IT_MANAGEMENT_COMPONENT.DISTRICTS]
      if (permission) {
        let prepareDynamicTableTabsFromPermissionsObj = prepareDynamicTableTabsFromPermissions(this.primengTableConfigProperties, permission);
        this.primengTableConfigProperties = prepareDynamicTableTabsFromPermissionsObj['primengTableConfigProperties'];
      }
    });
  }

  getDistricts(pageIndex?: string, pageSize?: string, otherParams?: object): void {
    this.loading = true;
    this.crudService.get(
      ModulesBasedApiSuffix.IT_MANAGEMENT,
      UserModuleApiSuffixModels.DIVISION_DISTRICT,
      undefined,
      false,
      prepareGetRequestHttpParams(pageIndex, pageSize, otherParams)).subscribe((response: IApplicationResponse) => {
        if (response.isSuccess && response.statusCode === 200) {
          this.dataList = response.resources
          this.totalRecords = response.totalCount;
          this.loading = false;
        }
        this.rxjsService.setGlobalLoaderProperty(false);
      });
  }

  onCRUDRequested(type: CrudType | string, row?: object, searchObj?: any): void {
    switch (type) {
      case CrudType.CREATE:
        if (checkUserPermissionsByCategory.bind(this, CrudType.CREATE)) {
          this.openAddEditPage(CrudType.CREATE, row);
        }
        break;
      case CrudType.VIEW:
        if (checkUserPermissionsByCategory.bind(this, CrudType.EDIT)) {
          this.openAddEditPage(CrudType.VIEW, row);
        }
        break;
      case CrudType.GET:
        this.first = row["pageIndex"] && row["pageSize"] ? row["pageIndex"] * row["pageSize"] : 0;
        switch (this.selectedTabIndex) {
          case 0:
            this.getDistricts(
              row["pageIndex"], row["pageSize"], searchObj);
            break;
        }
        break;
      case CrudType.DELETE:
        if (checkUserPermissionsByCategory.bind(this, CrudType.ROW_DELETE)) {
          this.reusablePrimeNGTableFeatureService.openDynamicDeleteDialog(this.selectedTabIndex, this.selectedRows,
            this.primengTableConfigProperties, row)?.onClose?.subscribe((result) => {
              if (result) {
                this.selectedRows = [];
                this.getDistricts();
              }
            });
        }
        break;
      case CrudType.STATUS_POPUP:
        this.reusablePrimeNGTableFeatureService.openDynamicChangeStatusDialog(this.selectedTabIndex,
          this.primengTableConfigProperties, row)?.onClose?.subscribe((result) => {
            if (!result) {
              this.dataList[searchObj].isActive = this.dataList[searchObj].isActive ? false : true;
            }
          });
        break;
    }
  }

  onActionSubmited(e) {
    onActionSubmittedUtil(e, this.onCRUDRequested.bind(this));
  }

  onChangeSelecedRows(e) {
    this.selectedRows = e;
  }

  openAddEditPage(type: CrudType | string, districtModel?: DistrictModel | any): void {
    let data = new DistrictModel(districtModel);
    const ref = this.dialogService.open(DistrictAddEditComponent, {
      showHeader: false,
      baseZIndex: 1000,
      width: '450px',
      data: data,
    });
    ref.onClose.subscribe((resp) => {
      if (!resp) {
        this.getDistricts();
      }
    })
  }
}
